<template>
  <div>
    <button
      v-if="showButton"
      @click="scrollToTop"
      class="scroll-to-top"
    >↑</button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showButton = ref(false)
const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

const handleScroll = () => showButton.value = window.scrollY > 800

onMounted(() => window.addEventListener('scroll', handleScroll))
onUnmounted(() => window.removeEventListener('scroll', handleScroll))
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  font-size: 18px;
  border-radius: 50%;
  cursor: pointer;
  background: var(--color-background-button-default);
  color: black;
  text-align: center;
  z-index: 1;
  width: 50px;
  height: 50px;
  cursor: pointer;

  @media (max-width: 768px) {
    bottom: 70px;
    right: 20px;
  }
}
</style>
